module.exports = "ng2-map {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    height: 100%;\r\n}\r\n\r\n\r\n/* .agent_locator_lhs:hover {\r\n    background-color: rgb(201, 201, 171);\r\n    cursor: pointer;\r\n} */"


//////////////////
// WEBPACK FOOTER
// ./src/app/agentLocator/agentlocator.component.css
// module id = ./src/app/agentLocator/agentlocator.component.css
// module chunks = main